import ApiService from './ApiService';

export default {
  /**
   * Returns all marketplaces
   * @returns {Promise<any>}
   */
  all() {
    return new Promise((resolve, reject) => {
      const data = {
        limit: 1000,
      };
      ApiService.request('GET', 'vendors', data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
